import { useTheme } from '@mui/material/styles';
import { Badge } from '../../../components/ui/Badge';
import { USER_BADGE_COLORS } from './userBadgeColors';

/** Rights-profile name as a shared badge in the mockup's `.chip` colours. */
export function ProfileBadge({ name }: { name: string }) {
  const theme = useTheme();
  const { color, bgcolor } = USER_BADGE_COLORS.default;

  return (
    <Badge
      label={name}
      color={color}
      bgcolor={bgcolor}
      fontWeight={theme.typography.fontWeightSemiBold}
    />
  );
}
